import { ViewModel,View } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { BankSelectorViewModel } from "src/erp/arap/rawData/bank/bankSelector-viewModel";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IReceiveInfoProvider } from "../IGateway";
import  { ChequeGatewayView } from "./chequeGateway-view"

export class ChequeGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = 'چک';
    }

    initialLoad() {
        this.district = new DistrictSelector(this);
        this.bankSelector = new BankSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new ChequeGatewayView();
    }
    public getTypeId(): string {
        return "VM-FA8DF276-D595-41F3-8317-F8C6D98CFD5E"
    }

    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set district(v: DistrictSelector) { this._district = v; } public get district(): DistrictSelector { return this._district;} private _district: DistrictSelector;
    public set bankSelector(v: BankSelectorViewModel) { this._bankSelector = v; } public get bankSelector(): BankSelectorViewModel { return this._bankSelector;} private _bankSelector: BankSelectorViewModel;
    public set chequeSerialNumber(v: string) { this._chequeSerialNumber = v; } public get chequeSerialNumber(): string { return this._chequeSerialNumber;} private _chequeSerialNumber: string;
    public set chequeTime(v: moment.Moment) { this._chequeTime = v; } public get chequeTime(): moment.Moment { return this._chequeTime;} private _chequeTime: moment.Moment;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set isForGuarantee(v: boolean) { this._isForGuarantee = v; } public get isForGuarantee(): boolean { return this._isForGuarantee;} private _isForGuarantee: boolean;

    async save(dataProvider: IReceiveInfoProvider): Promise<any> {
        return await ServerConnection.callServer('Complex/ArapServices/CreateChequeReceivable',{
            ReceivableInfo:dataProvider.getBaseReceivableInfoDto(),
            DistrictId:this.district.selectedItem.id,
            BankId:this.bankSelector.selectedItem.id,
            ChequeSerialNumber:this.chequeSerialNumber,
            ChequeTime:this.chequeTime,
            Reason:this.reason,
            IsGuarantee:this.isForGuarantee
        });
    }
    validate(): string[] {
        let result = [];
        if(this.district.selectedItem==null){
            result.push('صندوق مورد نظر انتخاب نشده است.');  
        }
        if(this.bankSelector.selectedItem==null){
            result.push('بانک مشخص نشده است.')
        }
        if(this.chequeTime==undefined){
            result.push('تاریخ چک مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.chequeSerialNumber)){
            result.push('شماره سریال چک مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.reason)){
            result.push('بابت مشخص نشده است.')
        }
        return result;
    }
}
